import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { setSubChildId } from "Administrator/modules/AdministratorModule";
import ContinuumLevels from "./routes/ContinuumLevels";
import ContinuumLevelsMapping from "./routes/ContinuumLevelsMapping";

export default store => ({
  path: "continuum-grading-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "continuum-grading-setup" */ "./components/ContinuumGradingSetup"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    store.dispatch(setSubChildId("CONTINUUM_GRADING_SETUP"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [ContinuumLevels(store), ContinuumLevelsMapping(store)],
});
